// 单文件引入方式

import Loading from './ZuiLoading.vue'

export default {
  install(Vue) {
    Vue.component('ZuiLoading', Loading)
  }
}

export { Loading }
